"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_ICON_BUTTON_SIZE = exports.REMOVE_ICON_BUTTON_ICON_SIZE = exports.QUANTITY_PICKER = void 0;
const REMOVE_ICON_BUTTON_SIZE = exports.REMOVE_ICON_BUTTON_SIZE = 25;
const REMOVE_ICON_BUTTON_ICON_SIZE = exports.REMOVE_ICON_BUTTON_ICON_SIZE = '1.6rem';
const QUANTITY_PICKER = exports.QUANTITY_PICKER = 'quantity-picker';
//# sourceMappingURL=constants.js.map